import script from "./CustomerOrdersModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerOrdersModal.vue?vue&type=script&setup=true&lang=js"

import "./CustomerOrdersModal.vue?vue&type=style&index=0&id=3916dd40&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3916dd40"]])

export default __exports__